export const GET_CALL_NOTIFICATION_REQUEST = "GET_CALL_NOTIFICATION_REQUEST";
export const GET_CALL_NOTIFICATION_SUCCESS = "GET_CALL_NOTIFICATION_SUCCESS";
export const GET_CALL_NOTIFICATION_FAILURE = "GET_CALL_NOTIFICATION_FAILURE";
